// src/utils/disable-autocorrect.js
//
// SaaS для магазинов: каждый магазин вводит свои названия товаров, имена,
// артикулы, описания на 7 языках. Системная автокоррекция (особенно на Android
// и iOS) постоянно срезает или искажает текст, особенно при потере фокуса
// после ввода кириллицы. Лечится атрибутами autoCorrect/autoCapitalize/
// spellCheck/autoComplete = "off" на каждом поле.
//
// Чтобы не переписывать все inputs в проекте, делаем глобально через
// MutationObserver: при появлении новых input/textarea в DOM — навешиваем
// нужные атрибуты автоматически.
//
// Исключения (явный opt-in для автозаполнения):
//   - input[type=email]                — email-подсказки полезны
//   - input[type=password]             — пароли в менеджерах
//   - elements с data-allow-autocorrect — ручное включение для конкретного поля

const TYPES_TO_PATCH = new Set(['text', 'search', 'tel', 'url', 'number', '']);

function shouldPatch(el) {
  if (!el) return false;
  if (el.dataset && el.dataset.allowAutocorrect === 'true') return false;

  const tag = el.tagName;
  if (tag === 'TEXTAREA') return true;
  if (tag !== 'INPUT') return false;

  // type не задан → text по умолчанию
  const type = (el.getAttribute('type') || 'text').toLowerCase();
  return TYPES_TO_PATCH.has(type);
}

function patchElement(el) {
  if (!shouldPatch(el)) return;
  // Не перезаписываем если уже выставлено
  if (!el.hasAttribute('autocorrect'))   el.setAttribute('autocorrect', 'off');
  if (!el.hasAttribute('autocapitalize')) el.setAttribute('autocapitalize', 'off');
  if (!el.hasAttribute('spellcheck'))    el.setAttribute('spellcheck', 'false');
  if (!el.hasAttribute('autocomplete'))  el.setAttribute('autocomplete', 'off');
}

function scanRoot(root) {
  if (!root || !root.querySelectorAll) return;
  for (const el of root.querySelectorAll('input, textarea')) {
    patchElement(el);
  }
}

let installed = false;

export function installDisableAutocorrect() {
  if (installed) return;
  installed = true;

  // Первичный проход по уже отрендеренному DOM
  scanRoot(document);

  // Наблюдатель за всеми будущими добавлениями
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;        // не Element
        if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
          patchElement(node);
        }
        // Сканируем поддерево если элемент-контейнер
        scanRoot(node);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
